import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import type { HTMLInputTypeAttribute } from 'react'

const StFieldContainer = styled.div<{
  noMargin?: boolean
  type?: HTMLInputTypeAttribute
}>`
  width: 100%;
  ${({ theme, noMargin }) => `
    margin-bottom: ${noMargin ? '0px' : theme.UI.SpacingPx.Space6};

    & > label {
      margin-bottom: ${theme.UI.SpacingPx.Space2};
    }

    `}
  ${({ type }) => type === 'hidden' && 'display: none;'}
`

const StInputContainer = styled.label<{ error?: boolean }>`
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  transition: all 0.3s ease;

  ${({ theme, error }) => {
    return `
      background-color: ${error ? theme.Components.Input.ErrorFill : theme.Components.Input.Fill};
      border: 1px solid ${error ? theme.Components.Input.ErrorBorder : theme.Components.Input.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;
      color: ${error ? theme.Components.Input.ErrorText : theme.Components.Input.Text};

      > .input,
      > input[type='search'],
      > input[type='time'] {
          padding: ${theme.UI.SpacingPx.Space4};
          padding-right: 0px;
          white-space: pre-wrap;
      };

      > input[type="date"]::-webkit-calendar-picker-indicator {
          display: none; /* Hides the icon in Chrome and Firefox < v109 */
      }

      > input {
        width: 100%;
        padding: ${theme.UI.SpacingPx.Space4};
        padding-right: 0px;

        &::placeholder {
          color: ${theme.Components.Input.Placeholder};
        }

        &:disabled {
          color: ${theme.Components.Input.DisabledText};
          border-color: ${theme.Components.Input.DisabledBorder};
          background-color: ${theme.Components.Input.DisabledFill};
        }
      }

      &:focus-within {
        outline: none;

        ${
          error
            ? ``
            : `
        border-color: ${theme.Components.Input.ActiveBorder};
        background-color: ${theme.Components.Input.ActiveFill};

        `
        }
      }
    `
  }}
`

const StInputIcon = styled(FontAwesomeIcon)`
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
`

const StInputErrorContainer = styled.div``

export { StFieldContainer, StInputContainer, StInputErrorContainer, StInputIcon }
